<template>
  <Lottie :width="width" :height="height" v-bind="lottieOptions" />
</template>

<script>
// import Lottie from 'vue-lottie/src/lottie.vue'
import loadingAnimationOrange from '@/assets/images/icon/loading.json'
import loadingAnimationWhite from '@/assets/images/icon/loading_white.json'

export default {
  name: 'Loading',
  components: {
    // Lottie,
  },
  props: {
    color: { type: String, default: 'white' },
    width: { type: Number, default: 40 },
    height: { type: Number, default: 40 },
  },
  data() {
    const loadingType = this.color === 'white' ? loadingAnimationWhite : loadingAnimationOrange
    return {
      lottieOptions: {
        animationData: loadingType,
      },
    }
  },
}
</script>
<style lang="scss" scoped>
.spinner {
  margin: 0 auto;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}

.spinner > div {
  width: 8px;
  height: 8px;

  border-radius: 100%;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce0 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
